import { media } from 'src/styles/designs';
import styled from 'styled-components';
import { ConstraintContainer } from 'src/components/common/ConstraintContainer';
import { Paragraph } from 'src/components/common/typography/Text';
import { useDictionary } from 'src/modules/products/hooks/useDictionary';
import { DictionaryCode } from 'src/models/pim/dictionaries';
import { ProductDTO } from 'src/models/pim';
import { useProductAttributes } from 'src/modules/products/hooks/useProductAttributes';
import { ProductAttributeCode } from 'src/models/pim/attributes';
import { head } from 'lodash';
import { useTranslateItem } from 'src/hooks/directus/useTranslateItem';
import Markdown from 'markdown-to-jsx';

const Container = styled.div`
  position: relative;
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: calc(100% + var(--footer-static-height));

    background: #f6f6f6;
  }
`;

const Content = styled.div`
  position: relative;
  z-index: 1;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1rpx solid #d6d6d6;

  ${media.w.greaterThanOrEqual.desktop} {
    padding-top: 30px;
  }
`;

const Description = styled(Paragraph).attrs({ as: 'div' })`
  font-size: 11px;
  max-width: 840px;
  ol {
    padding-left: 12px;
    li {
      list-style: decimal;
    }
  }
`;

export const ProductPageLegalMentions = (product: ProductDTO) => {
  const translateFn = useTranslateItem();

  const entries = useDictionary(DictionaryCode.LegalMentions);

  const { getProductAttribute } = useProductAttributes(product.attributes);

  const legalMentions =
    head(getProductAttribute(ProductAttributeCode.LegalMentions)) ??
    entries.find((entry) =>
      product.categories?.some((c) => c.categories_code === entry.code),
    );

  if (!legalMentions) {
    return null;
  }

  return (
    <Container>
      <ConstraintContainer>
        <Content>
          <Description>
            <Markdown>{translateFn(legalMentions).value}</Markdown>
          </Description>
        </Content>
      </ConstraintContainer>
    </Container>
  );
};
